import { render, staticRenderFns } from "./WorkplaceList.vue?vue&type=template&id=90139656"
import script from "./WorkplaceList.js?vue&type=script&lang=js&external"
export * from "./WorkplaceList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports